import { db, storage } from "../../firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

/**
 * Upload an issue (and optional screenshot) to Firestore + Storage.
 * Automatically includes userRole.
 * 
 * @param {Object} issueData - Issue details { title, category, description, file }
 * @param {Object} userData - User details { uid, email, userRole }
 * @returns {Promise<Object>} Uploaded issue document reference
 */
export const uploadIssue = async (issueData, userData) => {
  try {
    if (!userData?.uid) throw new Error("No user logged in");

    let fileUrl = null;

    // 🔹 Upload file if exists
    if (issueData.file) {
      const fileRef = ref(
        storage,
        `issueScreenshots/${userData.uid}/${Date.now()}_${issueData.file.name}`
      );
      await uploadBytes(fileRef, issueData.file);
      fileUrl = await getDownloadURL(fileRef);
    }

    // 🔹 Create Firestore document
    const issueDoc = {
      title: issueData.title,
      category: issueData.category,
      description: issueData.description,
      fileUrl,
      userId: userData.uid,
      userEmail: userData.email,
      userRole: userData.userRole,
      createdAt: serverTimestamp(),
      status:"pending",
    };

    const docRef = await addDoc(collection(db, "Issues"), issueDoc);
    console.log("✅ Issue uploaded:", docRef.id);

    return { id: docRef.id, ...issueDoc };
  } catch (error) {
    console.error("❌ Error uploading issue:", error);
    throw new Error(error.message || "Failed to upload issue");
  }
};
